<template>
  <div class="weather-item grid-item" :style="{ color, borderColor: color }">
    <div class="day">{{ day }}</div>
    <div class="weather-icon" v-if="astro">
      <img :src="`/img/weather/${isNight}/${currentCode}.svg`" />
    </div>
    <div class="temp-max">{{ max }}</div>
    <div class="temp-min">{{ min }}</div>
    <div class="tile-desc">{{ currentDesc }}</div>
  </div>
</template>

<script>
export default {
  name: "WeatherItem",
  props: ["date", "max", "min", "code", "desc", "astro"],
  computed: {
    color() {
      return "#" + (this.$route.params.color || "FFFFFF");
    },
    currentCode() {
      let cc = new Date().getHours();

      if (this.day !== "Today") {
        return this.code[12].weatherCode;
      } else return this.code[cc].weatherCode;
    },
    currentDesc() {
      let cc = new Date().getHours();

      if (this.day !== "Today") {
        return this.code[12].weatherDesc[0].value;
      } else return this.code[cc].weatherDesc[0].value;
    },
    isNight() {
      const sunset = this.formatTime(this.astro[0].sunset);
      const sunrise = this.formatTime(this.astro[0].sunrise);

      let cc = `${new Date().getHours()}:${new Date().getMinutes()}`;

      return cc >= sunrise ? (cc < sunset ? "day" : "night") : "night";
    },
    day() {
      let date = new Date().getDate();
      let wdate = new Date(this.date).getDate();
      let wday = new Date(this.date).getDay();
      const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ];
      if (!(date - wdate)) {
        return "Today";
      } else if (wdate - date === 1) {
        return "Tomorrow";
      } else {
        return days[wday];
      }
    }
  },
  methods: {
    formatTime(time12h) {
      const [time, modifier] = time12h.split(" ");

      let [hours, minutes] = time.split(":");

      if (hours === "12") {
        hours = "00";
      }

      if (modifier === "PM") {
        hours = parseInt(hours, 10) + 12;
      }

      return `${hours}:${minutes}`;
    }
  }
};
</script>

<style>
.panels-grid {
  justify-content: space-between;
}
.panels-grid .weather-item {
  text-align: center;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
    /* background: rgba(4,108,176,0.4)!important; */

}
.tile-desc {
  display: none;
  position: absolute;
  opacity: 0.02;
  bottom: 1px;
}

@media screen and (max-width: 3839px) {
  .weather-item .day {
    font-size: 26px;
    margin-top: 10px;
    height: 26px;
  }
  .weather-item .weather-icon img {
    margin-top: 15px;
    width: 70px;
    min-height: 55px;
  }
  .weather-item .temp-max {
    font-size: 110px;
    height: 100px;
  }
  .weather-item .temp-min {
    font-size: 46px;
    height: 43px;
    margin-top: 15px;
  }
}
@media screen and (min-width: 3840px) {
  .weather-item .day {
    font-size: 52px;
    margin-top: 54px;
    height: 52px;
  }
  .weather-item .weather-icon img {
    margin-top: 20px;
    width: 140px;
    min-height: 110px;
  }
  .weather-item .temp-max {
    font-size: 220px;
    height: 200px;
  }
  .weather-item .temp-min {
    font-size: 92px;
    height: 86px;
    margin-top: 30px;
  }
}
</style>
